import axios from 'axios';

const API = axios.create({
    //baseURL: "http://localhost:8000/security",
    baseURL:  "https://cigli-hastane-rest.azurewebsites.net/security"

});

export default API;
